import { Button, Dropdown, Table, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { IconCaretDown, IconMoreCircle } from 'components/icons'
import { regexUrl } from 'constants/regex'
import dayjs from 'dayjs'
import { GetListLoyaltyPointDisbursementRequestResponseItem } from 'generated/api'

import { thousandSeparator } from 'helpers/numbers'
import { useNavigate } from 'react-router-dom'

interface Props {
  isLoading: boolean
  data: GetListLoyaltyPointDisbursementRequestResponseItem[] | undefined
}

function SawitPoinTable(props: Props) {
  const navigate = useNavigate()
  const columnsOrder: ColumnsType<GetListLoyaltyPointDisbursementRequestResponseItem> = [
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">
            Tanggal Permintaan
          </Typography.Text>
        </div>
      ),
      dataIndex: 'requestDate',
      key: 'requestDate',
      render: text => (
        <div className="flex flex-col" data-testid="date">
          <Typography.Text className="font-medium text-gray-800">
            {text ? dayjs(text).format('DD/MM/YYYY HH:mm') : '-'}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Nama Pemohon</Typography.Text>
        </div>
      ),
      dataIndex: 'applicantsName',
      key: 'applicantsName',
      render: text => (
        <div data-testid="cell_name" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{text}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Department</Typography.Text>
        </div>
      ),
      dataIndex: 'department',
      key: 'department',
      width: '10%',
      render: text => (
        <div data-testid="cell_department" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{text}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Jenis Pencairan</Typography.Text>
        </div>
      ),
      dataIndex: 'disbursementType',
      key: 'disbursementType',
      render: text => (
        <div data-testid="cell_disbursement" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{text}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">
            Tujuan Pencairan
          </Typography.Text>
        </div>
      ),
      dataIndex: 'purpose',
      key: 'purpose',
      render: (text: string) => {
        const linkedText = text.replace(
          regexUrl,
          url => `<a href="${url}" target="_blank">${url}</a>`,
        )
        return (
          <div data-testid="cell_purpose" className="flex flex-col w-[200px]">
            <div
              className="font-medium text-gray-800"
              dangerouslySetInnerHTML={{ __html: linkedText }}
            />
          </div>
        )
      },
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Total SawitPoin</Typography.Text>
        </div>
      ),
      dataIndex: 'totalPoint',
      key: 'totalPoint',
      render: text => (
        <div data-testid="cell_totalPoint" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">
            {thousandSeparator(text)}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Total Penerima</Typography.Text>
        </div>
      ),
      dataIndex: 'totalRecipients',
      key: 'totalRecipients',
      render: text => (
        <div data-testid="cell_totalRecipients" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">
            {thousandSeparator(text)}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Status</Typography.Text>
        </div>
      ),
      dataIndex: 'status',
      key: 'status',
      width: '10%',
      render: text => (
        <div data-testid="cell_status" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{text}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <Typography.Text className="font-semibold text-gray-800">
          <IconMoreCircle data-testid />
        </Typography.Text>
      ),
      width: '5%',
      key: 'action',
      render: row => (
        <Dropdown
          placement="bottomRight"
          trigger={['click']}
          dropdownRender={() => (
            <div
              className="flex flex-col gap-3 p-4 bg-white rounded-md shadow-xl"
              data-testid="dropdown-detail"
            >
              <span className="font-semibold pt-2 px-3">Aksi</span>
              <span
                data-testid="select-detail"
                onClick={() => navigate(`/sawitpoin/detail/${row.id}`)}
                className="hover:bg-primary py-1 px-3 bg-white cursor-pointer hover:text-white rounded-lg"
              >
                Lihat Detail
              </span>
            </div>
          )}
          arrow
        >
          <Button data-testid="button-action" block className="bg-transparent">
            <Typography.Text className="font-medium cursor-pointer">
              <IconCaretDown />
            </Typography.Text>
          </Button>
        </Dropdown>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      loading={props.isLoading}
      data-testid="tbl_member"
      className="table-primary table-primary--admin table-sawitpoin"
      columns={columnsOrder}
      dataSource={props.data}
      pagination={false}
    />
  )
}

export default SawitPoinTable
